import { SortCode } from './direct.debit.model';

export enum DeliveryControls {
  FirstAvailableDate = 'firstAvailableDate',
  ExpectedDate = 'expectedDate',
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  AddressLine3 = 'addressLine3',
  AddressLine4 = 'addressLine4',
  PostCode = 'postCode',
  CountryCode = 'countryCode',
  Email = 'email',
  Mobile = 'mobile',
  Telephone = 'telephone',
  IsTelephoneOpen = 'isTelephoneOpen',
  AccessDifficulties = 'accessDifficulties',
  AccessInfo = 'accessInfo',
  Stairs = 'stairs',
  AdditionalInfo = 'additionalInfo',
  CheckSpecFieldDef = 'checkSpec',
  ProductionConnectionFieldDef = 'productionConnectionFieldDefieldDef',
}

export enum DeliveryErrors {
  AddressLine1Required = 'Enter an Address',
  AddressLine1Pattern = 'Enter a valid Address',
  AddressLine2Required = 'Enter an Address',
  AddressLine2Pattern = 'Enter a valid Address',
  AddressLine3Required = 'Enter an Address',
  AddressLine3Pattern = 'Enter a valid Address',
  AddressLine4Required = 'Enter an Address',
  AddressLine4Pattern = 'Enter a valid Address',
  PostCodeRequired = 'Enter a postCode',
  PostCodePattern = 'Enter a valid postCode',
  CountryCodeRequired = 'Enter a countryCode',
  CountryCodePattern = 'Enter a valid countryCode',
  EmailRequired = 'Enter an email',
  EmailPattern = 'Enter a valid email',
  ExpectedDateRequired = 'Please select a date.',
  MobileRequired = 'Enter a mobile number',
  MobilePattern = 'Enter a valid mobile',
  TelephoneRequired = 'Enter a telephone',
  TelephonePattern = 'Enter a valid telephone',
  AccessDifficultiesRequired = 'Please confirm if there are no parking access difficulties',
  CheckSpecRequired = 'Please confirm if there are specifiction issues',
  ProductionConnectionFieldDefRequired = 'Please confirm if there are electrical issues',
  StairsRequired = 'Please confirm if there are any stairs',
  NoDeliveryDates = 'Sorry, this product is no longer available. Please go back and choose another.',
  DeliveryDateTaken = 'Sorry, the last delivery for @date has just been taken. Please select another date.',
  DeliveryDatesLoading = 'Please wait while we check available dates',
}

export interface DeliveryForm {
  firstAvailableDate?: boolean;
  expectedDate?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  postCode?: string;
  countryCode?: string;
  email?: string;
  mobile?: string;
  telephone?: string;
  accessDifficulties?: string; // TODO can radio component accept true/false for yes/no
  accessInfo?: string;
  stairs?: string;
  additionalInfo?: string;
  isTelephoneOpen?: boolean;
}

export enum DirectDebitControls {
  MonthlyPayment = 'monthlyPayment',
  AccountHolderName = 'accountHolderName',
  AccountNumber = 'accountNumber',
  SortCode = 'sortCode',
  Sort1 = 'sort1',
  Sort2 = 'sort2',
  Sort3 = 'sort3',
  PreferredPaymentDay = 'preferredPaymentDay',
  PostPolicy = 'postPolicy',
}

export enum DirectDebitErrors {
  MonthlyPaymentRequired = 'Enter a monthly payment',
  MonthlyPaymentPattern = 'Enter a valid monthly payment',
  AccountHolderNameRequired = 'Enter an account name',
  AccountHolderNamePattern = 'Enter a valid account name',
  AccountNumberRequired = 'Enter an account number',
  AccountNumberPattern = 'Enter a valid account number',
  SortCodeRequired = 'Please enter a valid sort code',
  SortCodePattern = 'Please enter a valid sort code',
  PreferredPaymentDayRequired = 'Select a preferred payment day',
}

export enum FormStep {
  Delivery = 'delivery',
  SortCode = 'sortCode',
  DirectDebit = 'directDebit',
  UpfrontPayment = 'upfrontPayment',
}

export interface DirectDebitForm {
  monthlyPayment?: number;
  accountHolderName?: string;
  accountNumber?: string;
  sortCode?: SortCode;
  preferredPaymentDay?: string;
  postPolicy?: boolean;
}

export interface OrderForm {
  delivery?: DeliveryForm;
  directDebit?: DirectDebitForm;
  upfrontPayment?: null;
}

export const OrderForm = undefined;
